import api from "../service/atividade.service";
import * as types from "./atividade.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import atividadeActions from "./atividade.actions";
import atividadeSelector from "../store/atividade.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.MAIN_SAGA_ATIVIDADE, mainSagaAtividade);
  yield takeEvery(types.SET_SAGA_ATIVIDADE, setSagaAtividade);
  yield takeEvery(types.DELETE_SAGA_ATIVIDADE, deleteSagaAtividade);
  yield takeEvery(types.ADD_SAGA_ATIVIDADE, addSagaAtividade);
  yield takeEvery(types.SAGA_ATIVIDADE_REMOVER_BY_CNAE, atividadeRemoverByCnae);
  yield takeEvery(types.ADD_LISTA_ATIVIDADE, addListaAtividade);
}

function* addListaAtividade(action) {
  const { payload } = action;

  payload[0].Principal = 1

  yield put(atividadeActions.setAtividade(payload));
  
  yield put(formActions.gridReload());
}

function* addSagaAtividade(action) {
  const { payload } = action;

  yield put(atividadeActions.addAtividade(payload));

  yield put(formActions.gridReload());
}

function* atividadeRemoverByCnae(action) {
  const { payload } = action;
  let atividadeState = yield select(atividadeSelector.atividade);

  let atividadesVinculadaCnae = atividadeState.atividades.filter((x) =>
    x.IdsCnae.includes(payload.IdCnae)
  );

  let { atividades } = atividadeState;

  let atividadesArray = [...atividades];

  atividadesArray = atividadesArray.filter(
    (x) => !atividadesVinculadaCnae.includes(x)
  );

  if (
    atividadesArray &&
    atividadesArray.length > 0 &&
    !atividadesArray.some((item) => item.Principal == 1)
  ) {
    atividadesArray[0] = { ...atividadesArray[0], Principal: 1 };
  }

  yield put(atividadeActions.deleteAtividade(atividadesArray));
  yield put(formActions.gridReload());
}

function* setSagaAtividade(action) {
  const { payload } = action;
  yield put(atividadeActions.setAtividade(payload));
  yield put(formActions.gridReload());
}

function* mainSagaAtividade(action) {
  const { payload } = action;
  yield put(atividadeActions.mainAtividade(payload));
  yield put(formActions.gridReload());
}

function* deleteSagaAtividade(action) {
  const { payload } = action;

  let atividadeState = yield select(atividadeSelector.atividade);

  let { atividades } = atividadeState;

  let atividadesArray = [...atividades];

  atividadesArray = atividadesArray.filter(
    (x) => x.IdAtividade != payload.IdAtividade
  );

  if (payload.Principal && atividadesArray.length > 0) {
    atividadesArray[0] = { ...atividadesArray[0], Principal: 1 };
  }

  yield put(atividadeActions.deleteAtividade(atividadesArray));
  yield put(formActions.gridReload());
}
